import type { FilterSectionData } from '~/components/common/filters/MultiSectionFiltersFacetsWidget/FilterSections'
import type { Aggregation } from '~/types'

/**
 * Transforms aggregations data from the API into FilterSectionData format for facets
 */
export const transformAggregationsToFacets = (
  aggregations: Aggregation[] = [],
): FilterSectionData => {
  const facets: FilterSectionData = {}

  aggregations.forEach((aggregation) => {
    const { name, buckets } = aggregation

    facets[name] = Object.entries(buckets).map(([bucketName, count]) => ({
      id: bucketName,
      label: `${bucketName} (${count})`,
      value: bucketName,
      enabled: false, // Start with facets disabled
    }))
  })

  return facets
}
